/*
 Funções em JS puro utizadas para abrir modais nas telas de Login e Registro
*/
import tingle from "tingle.js";

export const modalConstructor = (_window = window) => {
	_window.modalDefaultInstance = new tingle.modal({
		footer: false,
		closeLabel: "",
		closeMethods: [],
		cssClass: ["modal-default"],
		onOpen: function() {
			document.querySelector(".tingle-modal").focus();
		}
	});
};

export const openModal = (
	{ content, hooks = false },
	modalDefaultInstance = window.modalDefaultInstance
) => {
	if (content !== null) {
		modalDefaultInstance.setContent(content);
		modalDefaultInstance.open();

		if (hooks) {
			hooks(modalDefaultInstance);
		}
	}
};

export const closeModal = (modalDefaultInstance = window.modalDefaultInstance) => {
	modalDefaultInstance.close && modalDefaultInstance.close();
};
